import { jsx } from 'react/jsx-runtime';
import { FlexBox, BaseTileTargetAdditional } from '@vp/swan';

const TemplateTileHeader = ({ children }) => /* @__PURE__ */ jsx(FlexBox, { justifyContent: "flex-end", children: /* @__PURE__ */ jsx(BaseTileTargetAdditional, { children }) });

export { TemplateTileHeader };
